export const feedTour = {
  key: "feed",
  version: 1,
  getSteps: (t) => [
    {
      target: "body",
      content: t("Tour_Feed_Overview"),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="feed-stories"]',
      content: t("Tour_Feed_Stories"),
      placement: "bottom",
    },
    {
      target: '[data-tour="feed-composer"]',
      content: t("Tour_Feed_Composer"),
      placement: "bottom",
    },
    {
      target: '[data-tour="feed-share"]',
      content: t("Tour_Feed_Share"),
      placement: "bottom",
    },
    {
      target: '[data-tour="feed-photo"]',
      content: t("Tour_Feed_Photo"),
      placement: "bottom",
    },
    {
      target: '[data-tour="feed-video"]',
      content: t("Tour_Feed_Video"),
      placement: "bottom",
    },
    {
      target: '[data-tour="feed-story"]',
      content: t("Tour_Feed_Story"),
      placement: "bottom",
    },
    {
      target: '[data-tour="feed-posts"]',
      content: t("Tour_Feed_Posts"),
      placement: "top",
    },
    {
      target: '[data-tour="feed-pagination"]',
      content: t("Tour_Feed_Pagination"),
      placement: "top",
    },
    {
      target: '[data-tour="feed-sidebar"]',
      content: t("Tour_Feed_Sidebar"),
      placement: "left",
    },
  ],
};